import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initHScroll } from './hscroll'; // [2026-11-04] เลื่อนแถวซ้าย-ขวาด้วยเมาส์ (Top 10 ฯลฯ)
// [2026-11-04] ไม่ได้ใช้แล้ว (render ถูก comment) แต่ยังลากโค้ดหน้าเก่า + @mui/icons-material ทั้งชุดเข้า bundle -> ตัดออกให้ไฟล์ JS เล็กลง
// import Navbar from './navbar';
import reportWebVitals from './reportWebVitals';
// [2026-11-04] ไม่ได้ใช้แล้ว (render ถูก comment) แต่ยังลากโค้ดหน้าเก่า + @mui/icons-material ทั้งชุดเข้า bundle -> ตัดออกให้ไฟล์ JS เล็กลง
// import Sidebar from './sidebar';
import Footer from './footer';
// [2026-11-04] ไม่ได้ใช้แล้ว (render ถูก comment) แต่ยังลากโค้ดหน้าเก่า + @mui/icons-material ทั้งชุดเข้า bundle -> ตัดออกให้ไฟล์ JS เล็กลง
// import Vthmese from './VThmese';
import $ from 'jquery';


if (process.env.NODE_ENV === "production")
  console.log = function no_console() { };





// const sidebar = ReactDOM.createRoot(document.getElementById('sidebar'));
// sidebar.render(
//   <>
//     < Navbar />
//   </>
// );

initHScroll();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
  </>
);

// const navbar = ReactDOM.createRoot(document.getElementById('navbar'));
// navbar.render(
//   <>
//     <Sidebar />
//   </>
// );

const footer = ReactDOM.createRoot(document.getElementById('footer'));
footer.render(
  <>
    <Footer />
  </>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(////console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
